import { put } from 'redux-saga/effects';
import { Types } from './actions';

export default function* saga(): any {
  try {
    yield put({ type: Types.GET_YEARS_OF_PROCEDURES_REQUEST });
    const years = [
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3,
      new Date().getFullYear() - 4
    ];
    yield put({
      type: Types.GET_YEARS_OF_PROCEDURES_SUCCESS,
      data: years.map((year) => year.toString()),
      selectedYear: years[0].toString()
    });
  } catch (error) {
    yield put({
      type: Types.GET_YEARS_OF_PROCEDURES_FAILURE,
      error: true
    });
  }
}
